import { Application } from "@hotwired/stimulus"
import { railsEnv } from "@uenf/layout"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}

import { layoutControllers } from "@uenf/layout"
for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}
